import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import "../../Users/users.css";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

type UsersListProps = {
  users: any;
  loading: boolean;
  tableKey: number;
};
interface UsersRoleInterface {
  id: string;
  fullName: string;
}
export const UsersListModal = ({
  users,
  loading,
  tableKey,
}: UsersListProps) => {
  const { t } = useTranslation("common");
  const [usersForRole, setUsersForRole] = useState();
  useEffect(() => {
    setUsersForRole(users.filter((user: any) => user.belongsToRole));
  }, [users]);
  // const navigate = useNavigate();
  // const [id, setId] = useState<number | undefined>();

  const columns: ColumnsType<UsersRoleInterface> = [
    {
      title: `${t("name")}`,
      dataIndex: "fullName",
      key: "fullName",
      width: "25rem",
      className: "table-header",
    },
    {
      title: `${t("user-id")}`,
      dataIndex: "id",
      key: "id",
      width: "5rem",
    },
  ];

  return (
    <>
      <Table
        key={tableKey}
        className="users-list"
        loading={loading}
        columns={columns}
        pagination={false}
        dataSource={usersForRole}
        rowKey={(record) => record.id}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
      />
    </>
  );
};

// to do:

// delete users
